function NewQuery(searchTerm, currentPage, labelsPerPage) {
  return {
    "query": {
      "function_score": {
        "query": {
          "bool": {
            "should": [
              {
                "match": {
                  "label.ngram": {
                    "query": searchTerm,
                    "boost": 10,
                    "_name": "ngram search * score_multiply_10"
                  }
                }
              },
              {
                "match": {
                  "label.strip_whitespace": {
                    "query": searchTerm,
                    "boost": 10,
                    "_name": "exact match * score_multiply_10"
                  }
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.transform1",
                          "label.transform2"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "transform exact match * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_double_last"
                        ]
                      }
                    }
                  ],
                  "boost": 8,
                  "_name": "JO and HNN * score_multiply_8"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_double",
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                            "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 6,
                  "_name": "(JO or JJ) and OHN * score_multiply_6"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_plus_s",
                          "label.last_3_chars_double_penultimate"
                        ]
                      }
                    }
                  ],
                  "boost": 6,
                  "_name": "JO and (HNS or HHN) * score_multiply_6"
                }
              },
              {
                "bool": {
                  "must": [
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "label.first_two_chars"
                          ]
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "label.last_2_chars_drop_last_keep_first_two"
                          ]
                        }
                      }
                  ],
                  "boost": 3,
                  "_name": "JO and HN? * score_multiply_3"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char_double": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                      "query": searchTerm,
                      "fields": [
                        "label.last_3_chars_plus_s",
                        "label.last_3_chars_double_last",
                        "label.last_3_chars_double_penultimate"
                        ]
                      }
                    }
                  ],
                  "boost": 4,
                  "_name": "JJ and (HNS or HNN or HHN) * score_multiply_4"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_double"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars_drop_last_keep_first_two"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "JJ and HN? * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "J and OHN * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "JO and ?HN * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_search_second_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_plus_s",
                          "label.last_3_chars_double_last",
                          "label.last_3_chars_double_penultimate"
                        ]
                      }
                    }
                  ],
                  "boost": 1,
                  "_name": "*J and (HNS or HNN or HHN) * score_multiply_1"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars_drop_last_keep_first_two"
                        ]
                      }
                    }
                  ],
                  "boost": 1,
                  "_name": "J and (HN*) * score_multiply_1"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_transform1_search_third_char",
                          "label.first_char_transform2_search_third_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1_search_fourth_char",
                          "label.second_char_transform2_search_fourth_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                      "query": searchTerm,
                      "fields": [
                        "label.last_3_chars",
                        "label.last_3_chars_plus_s",
                        "label.last_3_chars_double_last",
                        "label.last_3_chars_double_penultimate"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "**transform(J) and transform(O) and (OHN or HNS or HNN or HHN) *     score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_transform1_search_fourth_char",
                          "label.first_char_transform2_search_fourth_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                      "query": searchTerm,
                      "fields": [
                        "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "***transform(J) and OHN * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [ "label" ],
                        "fuzziness": 1
                      }
                    }
                  ],
                  "boost": 1,
                  "_name": "fuzzy * score_multiply_1"
                }
              }
            ],
            "filter": [
              {
                "term": {
                  "available": "true"
                }
              }
            ],
            "minimum_should_match": 1
          }
        },
        "functions": [
          {
            "filter": {
              "term": {
                "supplier_id": "19"
              }
            },
            "weight": 2
          }
        ],
        "score_mode": "multiply",
        "boost_mode": "multiply"
      }
    },
    "size": labelsPerPage,
    "from": (currentPage - 1) * labelsPerPage,
    "track_total_hits": true
  };
}

export default NewQuery;
